function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cp-1",
  d: "M7,32c0-8.93,4.77-17.18,12.5-21.65s17.27-4.47,25,0,12.5,12.72,12.5,21.65-4.77,17.18-12.5,21.65-17.27,4.47-25,0-12.5-12.72-12.5-21.65ZM25.39,21.36c-.74.41-1.2,1.2-1.2,2.04v17.19c0,.85.46,1.63,1.2,2.04.74.41,1.64.4,2.37-.05l14.06-8.59c.69-.43,1.12-1.18,1.12-2s-.43-1.57-1.12-2l-14.06-8.59c-.72-.44-1.63-.46-2.37-.05v.02Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/continuePlayingIc.840796b7.svg";
export { SvgComponent as ReactComponent };